<template>
    <div>
        <modal class="auto-create" :display="modalStatus.autoCreate" @modalStatus="closeModal" >
            <h1>自動收租</h1>
            <div class="auto-create-wrap">
                <div class="description">
                    開啟自動收租後，將於下期帳單的應繳日自動發送帳單給租客
                </div>
                <div class="setting">
                    <div class="title">
                        自動收租：{{isOpen}}
                    </div>
                    <div class="switch">
                        <rent-switch  v-model="value" :dValue="isAutoCreate" ></rent-switch>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setAutoCreate">儲存設定</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSwitch from '@/components/widge/RentSwitch.vue';
import { mapGetters } from 'vuex'

import { 
    apiSetAutoSendBill
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            value: false,
        }
    },
    props: {
        cid: Number,
        isAutoCreate: Boolean
    },
    // mounted () {
    //     if(this.modalStatus.autoCreate){
    //         this.$analytics.logEvent('自動收租', { screen_name: '自動收租'})
    //     }
    // },
    watch: {
        isAutoCreate: {
            handler: function (value) {
                this.value = value
            },
            immediate: true
        },
    },
    methods: {
        setAutoCreate: function () {
            this.$analytics.logEvent('送出自動收租', { screen_name: '送出自動收租'})
            let data = [{
                "contractCid" : this.cid,
                "autoCreate" : this.value,
            }]
            apiSetAutoSendBill(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$emit('saveAutoStatus');
                    this.closeModal()
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'autoCreate'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSwitch
    }
}
</script>
<style lang="scss"  >
    #modal.auto-create{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .auto-create-wrap{
                    padding: 0 32px 0 32px;
                    .description{
                        font-weight: 300;
                        line-height: 1.57;
                        margin-bottom: 20px;
                    }
                    .setting{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-top: 1px solid #f3f3f3;
                        border-bottom: 1px solid #f3f3f3;
                        padding: 23px 0;
                        margin-bottom: 120px;
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/autoCreate.vue